import React from "react";
import "./Modaal.css";
import pic1 from "../../img/pic1.png";
import * as BsXLg  from "react-icons/bs";
import { Link } from 'react-router-dom';

function Modaal({setModalOpen}) {
  return (
    <div className="modalBackground">
      <div className="modalContainer">

            <div className = 'acuntdiv '> Account



        <Link className="iconcolorchnge" >
            <BsXLg.BsXLg onClick={()=>setModalOpen(false)} />
          </Link>
          </div>

        <hr style={{width:"260px", border:'1px solid darkgray'}}/>
        <div className="divdivdiv">
          <div>
        <img src={pic1} className="divright"></img>
          </div>
        <div className="divfontgmail">
        <span className="rightdiv">wajahat ullah</span>
        <span >wajahatullahkhanwasti@gmail.com</span>
        </div>
        </div>

        <div className="divanother">
            <span> Add another account</span>
        </div>
        <hr className ='linedivall' style={{width:"260px", border:'1px solid darkgray'}}/>


        <span className="rightdivall">Profile and visibility</span>

        <span className="rightdivall">Activity</span>
        <span className="rightdivall">Cards</span>
        <span className="rightdivall">Settings</span>
      {/* <>hfdjhf jlh,dalhag.kg</> */}
        

        <hr className ='linedivall' style={{width:"260px", border:'1px solid darkgray'}}/>

        <span className="rightdivall">Help</span>
        <span className="rightdivall">Shortcuts</span>
        <hr className ='linedivall' style={{width:"260px", border:'1px solid darkgray'}}/>
        <span className="rightdivall">Log out</span>




      </div>
    </div>
  );
}

export default Modaal;